import { Cta, Reveal } from "@/components/landing/Shared";

export const FinalCta = () => (
  <section className="relative overflow-hidden bg-[var(--ink)] px-5 py-24 text-center text-[var(--cream)] sm:px-8 lg:py-32" data-testid="section-final">
    <div className="pointer-events-none absolute -right-40 -top-40 h-[520px] w-[520px] rounded-full border border-white/10" aria-hidden="true" />
    <Reveal className="relative mx-auto max-w-3xl">
      <h2 className="font-display text-4xl font-light leading-[1.1] tracking-tight sm:text-5xl lg:text-6xl" data-testid="final-heading">
        You're One Decision Away From Finally <em className="inline-block -rotate-1 bg-[var(--mauve)] px-3 text-white">Getting Unstuck</em>
      </h2>
      <p className="mt-6 text-lg text-[#eddcd9] sm:text-xl">Don't scroll past your blessing.</p>
      <div className="mt-10 flex flex-col items-center gap-5">
        <Cta testId="final-cta-button" variant="light" label="Yes, show me how" href="#get-access" />
        <a href="#get-access" className="text-sm font-semibold uppercase tracking-[0.16em] text-[var(--blush)] underline-offset-4 hover:underline" data-testid="final-unlock-link">
          I'm Ready! Unlock Boss Suite
        </a>
      </div>
    </Reveal>
  </section>
);
